export default {
  name: 'money',
  magic: (el, { Alpine }) => {
    return (cents, format) => {
      const symbol = window.store_currency_symbol || '$';
      // Get shop money format from global Shopify object or default
      const shopMoneyFormat = window.Shopify?.money_format || '${{amount}}';
      
      // Use provided format or fall back to shop format
      const formatString = format ? `${symbol}{{${format}}}` : shopMoneyFormat;
      
      if (typeof cents === 'string') { 
        cents = cents.replace('.', ''); 
      }
      
      cents = parseInt(cents) || 0;
      
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let value = '';

      function defaultOption(opt, def) {
        return (typeof opt === 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsPart = parts[1] ? (decimal + parts[1]) : '';

        return dollars + centsPart;
      }

      const match = formatString.match(placeholderRegex);
      if (!match) return formatString;

      switch(match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }
  }
}